import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "abstract-container" }
const _hoisted_2 = ["src"]
const _hoisted_3 = ["aria-expanded"]

import { ref } from "vue";

interface Props {
  abstractText: string;
}


export default /*@__PURE__*/_defineComponent({
  __name: 'AbstractSummary',
  props: {
    abstractText: {}
  },
  setup(__props: any) {

const ArrowIcon = require("../../assets/images/ArrowWhiteIcon.svg") as string;

const props = __props;

const abstractShow = ref(false);

function toggleCollapse() {
  abstractShow.value = !abstractShow.value;
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("button", {
      onClick: toggleCollapse,
      class: "toggle-button"
    }, [
      _createElementVNode("img", {
        src: _unref(ArrowIcon),
        class: _normalizeClass(["toggle-button-icon", abstractShow.value ? 'arrow-up' : 'arrow-down'])
      }, null, 10, _hoisted_2),
      _cache[0] || (_cache[0] = _createTextVNode(" Abstract "))
    ]),
    _createElementVNode("div", {
      class: "collapse",
      "aria-expanded": abstractShow.value
    }, _toDisplayString(props.abstractText), 9, _hoisted_3)
  ]))
}
}

})